<!-- 审核账户信息 -->
<script setup>
// import i18n from "@/i18n"
import { ref, defineProps, toRefs, onMounted, defineExpose, defineEmits, watch } from "vue"
import { showMessage } from "@/utils/hooks/message"
import {
    getCompanyNameList,
    put_my_supply_chain_v3,
    post_my_supply_chain_v3,
    getCompanyRoleList,
} from "@/service/apiList/supplyChain"
import Swal from "sweetalert2";
import { getLangValue } from "@/utils/common"; //获取后端语言
// import { fa } from "element-plus/es/locale/index.mjs";
const props = defineProps({
    showType: {
        type: String,
        required: true,
        default: () => 'add'
    },
})
const emits = defineEmits(['updateTable', 'update:showType'])
const setting_role_list = ref([])
const company_list = ref([])
const detailData = ref([])
const formData = ref({
    id: '',
    name: '',
    type: '',
    contacts: '',
    email: '',
    phone: '',
    description: '',
    // 供应链配置信息
    setting: [
        {
            company_name: '',
            role: [],
            contact: '',
            email: '',
        }
    ],
})
const company_name_list = ref([
    []
])
const loadingList = ref([false])
const isCheckForm = ref(false)
const { showType } = toRefs(props)
const checkForm = () => {
    // 验证form
    isCheckForm.value = true;
    let checkRes = true
    if (!formData.value.name || !formData.value.type || formData.value.setting.length == 0
    ) {
        checkRes = false;
    }

    // 配置信息验证
    for (let key in formData.value.setting) {
        if (!formData.value.setting[key].company_name || !formData.value.setting[key].role || formData.value.setting[key].role.length==0
        ) {
            checkRes = false;
            break;
        }
    }


    return checkRes;
}

const editInfo = () => {
    emits('update:showType', 'edit')
}
const okFunction = async () => {
    const res = checkForm();
    if (!res) {
        showMessage(
            'danger',
            getLangValue("base.requiredinformation")
        );
        return
    }
    // 验证邮箱
    if (formData.value.email) {
        // 邮箱格式
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!regex.test(formData.value.email)) {
            showMessage(
                'danger',
                getLangValue("login.message10")
            );
            return
        }
    }
    // 验证重复数据
    let arrName = formData.value.setting.map(item => item.company_name)
    if (new Set(arrName).size !== arrName.length) {
        showMessage('danger', getLangValue('my.supply-chain','company_name_repeat'));
        return
    }

    // 提交数据
    let params = {
        name: formData.value.name,
        type: formData.value.type,
        contact_person: formData.value.contacts,
        email: formData.value.email,
        contact_phone: formData.value.phone,
        description: formData.value.description,
        company_list: formData.value.setting.map(item => {
            return {
                user_id: item.company_name,
                supply_chain_role: item.role,
                // contact: item.contact,
                // email: item.email
            }
        })
    }
    if (showType.value === 'add') {
        const res = await post_my_supply_chain_v3(params)
        if (res.code === 0) {
            showMessage('success', getLangValue("base.add_success"));
            document.getElementById('cancelBTn').click()
            emits('updateTable')
            isCheckForm.value = false
        } else {
            showMessage('danger', res.message);
        }
    } else {
        const res = await put_my_supply_chain_v3(formData.value.id, params)
        if (res.code === 0) {
            showMessage('success', getLangValue("base.edit_success"));
            document.getElementById('cancelBTn').click()
            emits('updateTable')
            isCheckForm.value = false
        } else {
            showMessage('danger', res.message);
        }
    }
}

// const getRoleName = (id) => {
//     /**获取角色名称 */
//     if (!id) return "";
//     const arr = setting_role_list.value.filter(item => item.id === id)
//     if (arr.length) {
//         return arr[0].name
//     }
//     return "";
// }

const getRoleName1 = (idArr) => {
    /**获取角色名称 */
    if (!idArr) return "";
    let arrName = []
    for (const item1 in idArr) {
        const arr = setting_role_list.value.filter(item => item.id === idArr[item1])
        if (arr.length) {
            arrName.push(arr[0].name)
        }
    }

    return arrName.join(",");
}

const addSetting = () => {
    /***添加配置 */
    formData.value.setting.push({
        company_name: '',
        role: [],
        contact: '',
        email: '',
    })
    company_name_list.value.push([])
    loadingList.value.push(false)
}
const removeSetting = (i) => {
    /***
     * !删除
     * @param i index
     *  */
    Swal.fire({
        title: getLangValue("base.delete_alert_title"),
        text: getLangValue("base.delete_alert_info"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: getLangValue("base.done"),
        cancelButtonText: getLangValue("base.cancel"),
    }).then(async (result) => {
        if (result.isConfirmed) {
            // !: 删除数据
            formData.value.setting.splice(i, 1);
            company_name_list.value.splice(i, 1);
            loadingList.value.splice(i, 1);

        }
    });
}

const getCompanyList = async () => {
    /**获取企业列表 */
    const resp = await getCompanyNameList();
    if (resp.code === 0) {
        company_list.value = resp.payload;
        getRoleList();
    } else {
        showMessage('danger', resp.msg);
    }
}

const getRoleList = async () => {
    /**获取角色列表 */
    const resp = await getCompanyRoleList();
    if (resp.code === 0) {
        setting_role_list.value = resp.payload;
    } else {
        showMessage('danger', resp.msg);
    }
}

const remoteMethod = async (query, key) => {
    /**远程搜索 */
    if (query) {
        loadingList.value[key] = true
        // const resp = await getCompanyNameList({ keyword: query });
        // loadingList.value[key] = false
        // if (resp.code === 0) {
        //     company_name_list.value[key] = resp.payload;
        //     console.log(company_name_list.value[key]);
        //     if (type) changeCompany(key)
        // } else {
        //     showMessage('danger', resp.msg);
        // }
        // 不区分大小写
        company_name_list.value[key] = company_list.value.filter(item => item.company_name.toLowerCase().includes(query.toLowerCase()))
        loadingList.value[key] = false
    } else {
        company_name_list.value[key] = []
    }
}

const changeCompany = (i) => {
    /**切换企业 */
    // console.log(i);
    formData.value.setting[i].contact = '';
    formData.value.setting[i].email = '';
    // console.log(formData.value.setting[i].company_name);
    // console.log(company_name_list.value[i]);
    if (formData.value.setting[i].company_name) {
        let arr = company_name_list.value[i].filter(item => item.id === formData.value.setting[i].company_name)
        if (arr.length) {
            // console.log(arr);
            formData.value.setting[i].contact = arr[0].contact_first_name + ' ' + arr[0].contact_last_name;
            formData.value.setting[i].email = arr[0].contact_email;
        }
    }
    // 验证是否有重复的数据
    if (formData.value.setting.some((item, index) => item.company_name === formData.value.setting[i].company_name && index !== i)) {
        showMessage('danger', getLangValue('my.supply-chain','company_name_repeat'));
    }
}
watch(detailData, (val) => {
    // console.log(val);
    // 需要执行搜索  否则无法复现
    val.forEach((item, index) => {
        remoteMethod(item.label, index)
    })
}, { deep: true })


onMounted(() => {
    getCompanyList();
})

defineExpose({
    formData,
    detailData
})
</script>
<template>
    <div id="myModal" class="modal" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="false" aria-modal="false"
        data-bs-backdrop="static" style="height: 900px;overflow-x: hidden !important; overflow-y: hidden !important;">
        <div class="modal-dialog "
            style="top: 20px;max-width: 1000px !important; width: 80%; height: calc(100% - 40px );;">
            <div class="modal-content " style="border: unset;height: 100%;">
                <div class="modal-header pb-2" style="background-color: #333a54;color: white;">
                    {{ showType == 'add' ? getLangValue('my.supply-chain','add') : showType == 'edit' ? getLangValue('my.supply-chain','edit') :
                        formData.name }}
                </div>
                <div class="modal-body px-4" style="height: calc(100% - 120px - 3rem);">
                    <div class="row  d-flex justify-content-between">
                        <div class="col-6 mt-2">
                            <label class="form-label" style="font-weight: bold;">
                                <span class="text-danger" v-if="showType != 'view'">*</span>
                                <span>{{ getLangValue('my.supply-chain','tableHeader1') }}</span>
                            </label>
                            <div class="d-flex align-items-center">
                                <span class="ms-4" v-if="showType == 'view'">
                                    {{ formData.name }}
                                </span>
                                <input v-else clearable type="text" class="form-control" v-model="formData.name"
                                    :class="[(isCheckForm && !formData.name) && 'is-invalid']"
                                    style="display: inline; flex:1" />
                            </div>
                        </div>
                        <div class="col-6 mt-2">
                            <label class="form-label" style="font-weight: bold;">
                                <span class="text-danger" v-if="showType != 'view'">*</span>
                                <span>{{ getLangValue('my.supply-chain','placeholder2') }}</span>
                            </label>
                            <div class="d-flex align-items-center">
                                <span class="ms-4" v-if="showType == 'view'">
                                    {{ formData.type }}
                                </span>
                                <input v-else clearable v-model="formData.type" type="text" class="form-control"
                                    :class="[(isCheckForm && !formData.type) && 'is-invalid']"
                                    style="display: inline; flex:1" />
                            </div>
                        </div>
                        <div class="col-4 my-4">
                            <label class="form-label" style="font-weight: bold;">
                                <!-- <span class="text-danger" v-if="showType != 'view'">*</span> -->
                                <span>{{getLangValue('my.account', 'form_contacts') }}</span>
                            </label>
                            <div class="d-flex align-items-center">
                                <span class="ms-4" v-if="showType == 'view'">
                                    {{ formData.contacts }}
                                </span>
                                <input v-else clearable type="text" v-model="formData.contacts" class="form-control"
                                    style="display: inline; flex:1" />
                            </div>
                        </div>
                        <div class="col-4 my-4">
                            <label class="form-label" style="font-weight: bold;">
                                <!-- <span class="text-danger" v-if="showType != 'view'">*</span> -->
                                <span>{{ getLangValue('attribute.mobile') }}</span>
                            </label>
                            <div class="d-flex align-items-center">
                                <span class="ms-4" v-if="showType == 'view'">
                                    {{ formData.phone }}
                                </span>
                                <input v-else clearable type="text" v-model="formData.phone" class="form-control"
                                    style="display: inline; flex:1" />
                            </div>
                        </div>
                        <div class="col-4 my-4">
                            <label class="form-label" style="font-weight: bold;">
                                <span class="text-danger"></span>
                                <span>{{ getLangValue('attribute.email') }}</span>
                            </label>
                            <div class="d-flex align-items-center">
                                <span class="ms-4" v-if="showType == 'view'">
                                    {{ formData.email }}
                                </span>
                                <input v-else clearable type="text" v-model="formData.email" class="form-control"
                                    style="display: inline; flex:1" />
                            </div>
                        </div>
                        <div class="col-12 ">
                            <label class="form-label" style="font-weight: bold;">
                                <span class="text-danger"></span>
                                <span>{{ getLangValue('attribute.description') }}</span>
                            </label>
                            <div class="d-flex align-items-center">
                                <span class="ms-4" v-if="showType == 'view'">
                                    {{ formData.description }}
                                </span>
                                <textarea v-else clearable v-model="formData.description" class="form-control"
                                    style="display: inline; flex:1"></textarea>
                            </div>
                        </div>
                    </div>
                    <!-- 供应链配置信息 -->
                    <div class="card mt-4" style="height: calc(100% - 270px - 3rem);">
                        <div class="card-header">
                            {{ getLangValue('my.supply-chain','setting') }}
                        </div>
                        <div class="card-body" style="height: calc(100% - 54px - 2rem);">
                            <div class="my-scroll-bar" style="max-height: calc(100% - 30px - 0.5rem);overflow-y: auto;">
                                <div class="d-flex py-2" style="border-bottom: 1px solid #E9EBEC;">
                                    <div style="flex: 1;font-weight: bold;"> <span class="text-danger"
                                            v-if="showType != 'view'">*</span>{{ getLangValue('my.supply-chain','tableHeader1_1') }}
                                    </div>
                                    <div style="flex: 1;font-weight: bold;"> <span class="text-danger"
                                            v-if="showType != 'view'">*</span>{{ getLangValue('my.supply-chain','setting_role') }}</div>
                                    <div style="flex: 1;font-weight: bold;">{{getLangValue('my.account', 'form_contacts') }}</div>
                                    <div style="flex: 1;font-weight: bold;">{{ getLangValue('attribute.email') }}</div>
                                </div>
                                <!-- 信息 -->
                                <div class="d-flex py-2 align-items-center" style="border-bottom: 1px solid #E9EBEC;"
                                    v-for="(item, key) in formData.setting" :key="key">
                                    <div style="flex: 1;">
                                        <span v-if="showType == 'view'">
                                            {{ item.company_name1 }}
                                        </span>
                                        <el-select v-else style="width: 90%;height: 100%;" v-model="item.company_name"
                                            @change="changeCompany(key)" filterable :loading="loadingList[key]"
                                            :remote-method="(query) => remoteMethod(query, key)" remote
                                            :class="[(isCheckForm && !item.company_name) && 'is-invalid']"
                                            :placeholder="getLangValue('my.supply-chain','tableHeader1_1')" size="large" clearable>
                                            <el-option v-for="item1 in company_name_list[key]" :key="item1.key"
                                                :label="item1.company_name" :value="item1.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div style="flex: 1;">
                                        <span v-if="showType == 'view'">
                                            {{ getRoleName1(item.role) }}
                                        </span>
                                        <el-select v-else style="width: 90%;height: 100%;" v-model="item.role"
                                            collapse-tags multiple filterable
                                            :class="[(isCheckForm && (!item.role || item.role.length ==0)) && 'is-invalid']"
                                            :placeholder="getLangValue('my.supply-chain','setting_role')" size="large" clearable>
                                            <el-option v-for="item1 in setting_role_list" :key="item1.id"
                                                :label="item1.name" :value="item1.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div style="flex: 1;">
                                        {{ item.contact }}
                                    </div>
                                    <div style="flex: 1;" class="d-flex justify-content-between align-item-center">
                                        <span>{{ item.email }}</span>
                                        <i class="fs-16 ri-delete-bin-5-fill cursor-pointer text-danger me-2"
                                            @click="removeSetting(key)" v-if="showType != 'view'"></i>
                                    </div>
                                </div>
                            </div>
                            <!-- 新增 -->
                            <div class="mt-2 cursor-pointer" style="color: #8591A2; text-align: center;"
                                v-if="showType != 'view'">
                                <i class="fs-20 ri-add-circle-fill " @click="addSetting"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light" data-bs-dismiss="modal">{{
                        getLangValue('base.cancel') }}</button>
                    <button id="cancelBTn" type="button" class="btn btn-light" data-bs-dismiss="modal"
                        style="display: none;">{{
                            getLangValue('base.cancel') }}</button>
                    <button @click="editInfo" type="button" class="btn btn-primary "
                        v-if="showType == 'view' && formData.disabled"
                        style="background-color: #0AB39C;border-color: unset;">{{ getLangValue('base.edit') }}</button>
                    <button @click="okFunction" type="button" class="btn btn-primary " v-if="showType !== 'view'"
                        style="background-color: #0AB39C;border-color: unset;">{{ getLangValue('base.confirm') }}</button>
                </div>

            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div>
</template>

<style scoped lang="scss">
@media (min-width: 576px) {
    .modal-dialog {
        max-width: unset;
    }
}

.is-invalid {
    :deep(.el-select__wrapper) {
        border: 1px solid #f06548;
    }

}

:deep(.el-select__placeholder.is-transparent) {
    font-size: 0.8125rem;
    color: #878a99 !important;
}

:deep(.el-select__selected-item.el-select__placeholder) {
    font-size: 0.8125rem;
    color: #212529;
}

:deep(.el-cascader .el-input__inner) {
    font-size: 0.8125rem;
    color: #212529;
}

:deep(.el-cascader .el-input__inner::placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-webkit-input-placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-moz-placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-moz-placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-ms-input-placeholder) {
    color: #878a99;
}
</style>